import axios from 'axios';
import Vue from 'vue';
import bootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import translation from './translation';

function fileExists(url) {
  const http = new XMLHttpRequest();
  http.open('HEAD', url, false);
  http.send();
  return http.status !== 404;
}

axios.get('./config.json')
  .then((resp) => {
    Vue.use(bootstrapVue);
    Vue.prototype.$config = resp.data;
    Vue.config.productionTip = false;
    Vue.prototype.$translation = translation;
    Vue.prototype.$exists = fileExists;
    new Vue({
      router,
      render: (h) => h(App),
    }).$mount('#app');
  })
  .catch((err) => console.error(err));
